import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { CreateCategoryDialog } from "@/components/categories/CreateCategoryDialog";

interface ServiceCategorySelectorProps {
  categoryId: string | null;
  userCategories: any[];
  onUpdateCategory: (categoryId: string) => void;
  isMobile: boolean;
  onCreateCategory: (name: string) => Promise<string | null>;
}

export const ServiceCategorySelector = ({
  categoryId,
  userCategories,
  onUpdateCategory,
  isMobile,
  onCreateCategory
}: ServiceCategorySelectorProps) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [saving, setSaving] = useState(false);

  const handleValueChange = (value: string) => {
    if (value === "create-new") {
      setDialogOpen(true);
    } else {
      onUpdateCategory(value);
    }
  };

  const handleDialogCreate = async () => {
    if (!newCategoryName.trim()) return;
    setSaving(true);
    const newId = await onCreateCategory(newCategoryName.trim());
    setSaving(false);
    if (newId) {
      setDialogOpen(false);
      setNewCategoryName("");
      onUpdateCategory(newId);
    }
  };

  return (
    <div>
      <Select
        value={categoryId || ""}
        onValueChange={handleValueChange}
      >
        <SelectTrigger className={`${isMobile ? 'w-full' : 'w-[180px]'}`}>
          <SelectValue placeholder={t('services.selectCategory')} />
        </SelectTrigger>
        <SelectContent>
          {userCategories.map(category => (
            <SelectItem key={category.id} value={category.id}>
              {category.name}
            </SelectItem>
          ))}
          <SelectItem value="create-new" className="text-gebeya-pink font-medium">
            {t('services.createNewCategory')}
          </SelectItem>
        </SelectContent>
      </Select>
      <CreateCategoryDialog
        isOpen={dialogOpen}
        onOpenChange={setDialogOpen}
        categoryName={newCategoryName}
        onCategoryNameChange={setNewCategoryName}
        onCreateCategory={handleDialogCreate}
      />
    </div>
  );
};
